<template>
  <div>
    <div class="modal-content">
      <div class="modal-header" style="border-bottom: unset">
        <button
          type="button"
          class="close close-modal-button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row pl-md-5 pr-md-5">
          <div class="col-md-12 mb-3 d-flex justify-content-between">
            <h5 class="text-uppercase" v-if="eventData.id">
              BEWERK ACTIVITEIT
            </h5>
            <h5 class="text-uppercase" v-else>Nieuwe activiteit</h5>

            <div v-if="eventData.id">
              <button
                v-if="!pdf_loading"
                class="btn btc-sm btn-dark"
                @click="downloadAbsentiePdf(eventData.id)"
              >
                Downloaden
              </button>
              <button v-else class="btn btc-sm btn-dark">
                Downloading...
              </button>
            </div>
          </div>
          <div class="col-12">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Details
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12" v-if="eventtypes.length">
                        <div class="form-group">
                          <label class="mb-3">Activiteittype:</label><br />
                          <Select2
                            @change="eventtypeSelected()"
                            v-model="eventData.eventtype_id"
                            :options="
                              eventtypes.map((d) => {
                                return { text: d.title, id: d.id };
                              })
                            "
                          ></Select2>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <input
                            v-model="eventData.active"
                            id="active"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="active" class="ml-4">Actief</label>

                          <input
                            v-model="eventData.public"
                            id="public"
                            class="form-check-input ml-4 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="public" class="ml-5">Publiek</label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label for="name_event">Naam</label>
                          <input
                            v-model="eventData.title"
                            type="text"
                            class="form-control"
                            id="name_event"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label for="name_event">Adres</label>
                          <input
                            v-model="eventData.address"
                            type="text"
                            class="form-control"
                            id="name_event"
                          />
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="row">
                          <div class="form-group col-6">
                            <label for="">Startdatum</label>
                            <input
                              :disabled="eventtype_config != null"
                              v-model="eventData.date_start"
                              type="datetime-local"
                              class="form-control"
                            />
                          </div>
                          <div class="form-group col-6">
                            <label for="">Einddatum</label>
                            <input
                              :disabled="eventtype_config != null"
                              v-model="eventData.date_end"
                              type="datetime-local"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <p
                          v-if="
                            eventtype_config != null &&
                              eventtype_reoccurent_label != null
                          "
                        >
                          Herhalend:
                          <span class="text-success">{{
                            eventtype_reoccurent_label
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card"
                v-if="eventData.eventtype && eventData.eventtype.absence == 0"
              >
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Absentie
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <label for="" class="mt-3"
                          >Een lid toevoegen aan de aanwezigheidslijst</label
                        >
                        <Select2
                          @change="addUserToAttandee()"
                          :options="
                            users.map((d) => {
                              return { id: d.id, text: d.display_name };
                            })
                          "
                          v-model="selected_user"
                        ></Select2>
                        <table
                          style="max-height: 300px"
                          class="table table-responsive"
                        >
                          <thead>
                            <tr>
                              <th>Lid</th>
                              <th>Aanwezig</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(user, index) in eventData.attendees"
                              :key="'absentie_user_' + index"
                            >
                              <td>{{ user.display_name }}</td>
                              <td>
                                <div class="form-check">
                                  <input
                                    type="checkbox"
                                    class="form-check-input"
                                    :id="'absentieUser_' + user.id"
                                    v-model="user.selected"
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Omschrijving
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThree"
                  class="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Omschrijving</label>
                          <editor
                            v-model="eventData.description"
                            :init="{
                              height: 200,
                              menubar: false,
                              language: 'nl',
                              plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount',
                              ],
                              toolbar:
                                'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                            }"
                          />
                        </div>

                        <div class="row">
                          <div v-if="absentie" class="col-md-12">
                            <span class="mr-3">
                              <input
                                v-model="eventData.absent"
                                id="absent"
                                class="form-check-input ml-1 mt-1"
                                type="checkbox"
                                value=""
                              />
                              <label for="absent" class="ml-4">Absentie</label>
                            </span>
                            <span>
                              <input
                                v-model="eventData.absentMember"
                                id="absentMember"
                                class="form-check-input ml-1 mt-1"
                                type="checkbox"
                                value=""
                              />
                              <label for="absentMember" class="ml-4"
                                >Absentie door deelnemers</label
                              >
                            </span>

                            <div
                              v-if="eventData.absent || eventData.absentMember"
                              class="col-12"
                            >
                              <div class="col-md-12 col-12 mb-3 p-0">
                                Absentie verantwoordelijke(n):
                              </div>
                              <Multiselect
                                searchable
                                mode="tags"
                                v-model="eventData.selected_absentMembers"
                                :options="members"
                              />
                            </div>
                            <div
                              v-if="eventTypeAbsenceByAttendees"
                              class="col-12 mt-3 d-flex"
                            >
                              <div class="class">
                                <label for="">
                                  <span v-if="eventData.absence_by_attendees"
                                    >Afmelden</span
                                  >
                                  <span v-else>Aanmelden</span>
                                </label>
                                <VueToggles
                                  :value="eventData.absence_by_attendees"
                                  @click="
                                    eventData.absence_by_attendees = !eventData.absence_by_attendees
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFour">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Opmerkingen
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFour"
                  class="collapse"
                  aria-labelledby="headingFour"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Opmerkingen</label>
                          <editor
                            v-model="eventData.remarks"
                            :init="{
                              height: 200,
                              menubar: false,
                              language: 'nl',
                              plugins: [
                                'advlist autolink lists link image charmap print preview anchor',
                                'searchreplace visualblocks code fullscreen',
                                'insertdatetime media table paste code help wordcount',
                              ],
                              toolbar:
                                'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help',
                            }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingFive">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Leden
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFive"
                  class="collapse"
                  aria-labelledby="headingFive"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Groepen / Commissies:</label>
                          <Multiselect
                            searchable
                            mode="tags"
                            v-model="eventData.selected_committees"
                            :options="committees"
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Leden:</label>
                          <Multiselect
                            searchable
                            mode="tags"
                            v-model="eventData.selected_members"
                            :options="members"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingSix">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      Informatie
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseSix"
                  class="collapse"
                  aria-labelledby="headingSix"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Informatiegroep:</label>
                          <Multiselect
                            searchable
                            mode="tags"
                            v-model="eventData.itemgroups"
                            :options="itemgroups"
                          />
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="form-group">
                          <label for="">Informatie:</label>
                          <Multiselect
                            searchable
                            mode="tags"
                            v-model="eventData.selected_items"
                            :options="items"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body" v-if="eventData.id">
          <div class="form-check ml-4">
            <input type="checkbox" class="form-check-input" id="canceled" />
            <label class="form-check-label" for="canceled">Geannuleerd</label>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="ml-4 text-danger">{{ errormsg }}</p>
          </div>
          <div class="col-lg-12">
            <button @click="createEvent()" class="btn-dark float-right mt-3">
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "Eventform",
  props: {
    event: {},
    eventtypes: null,
    forceUpdate: null,
    committee: null,
    start_date: null,
    absentie: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      committees: [],
      members: [],
      create_event: {},
      eventData: {
        active: 1,
        public: 1,
        absence_by_attendees: false,
        selected_absentMembers: [],
        itemgroups: [],
        remarks: "",
      },
      errormsg: "",
      eventtype_config: null,
      event_selected_committees: [],
      items: [],
      eventTypeAbsenceByAttendees: false,
      itemgroups: [],
      pdf_loading: false,
      users: [],
      selected_user: null,
    };
  },
  computed: {
    ...mapState({
      selectedMembers: (state) => state.selectedMembers,
    }),
    eventtype_reoccurent_label() {
      var label = "";
      if (this.eventtype_config != null) {
        var options = this.$store.state.eventtype_config.reoccurrences;
        var result = options.find(
          (d) => d.value == this.eventtype_config.reoccurence_type
        );
        if (result) label = result.label;
      }
      return label;
    },
  },
  methods: {
    downloadAbsentiePdf(id) {
      this.pdf_loading = true;
      axios
        .get(
          process.env.VUE_APP_API_BASE_URL + `/api/v1/absentie/event/${id}/pdf`,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          this.pdf_loading = false;

          const type = data.headers["content-type"];
          const blob = new File([data.data], { type: type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "pdf.pdf";
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.pdf_loading = false;
        });
    },
    addUserToAttandee() {
      let user = this.users.find((elm) => elm.id == this.selected_user);
      user.selected = true;
      this.eventData.attendees.push(user);
    },
    createEvent() {
      console.log(this.eventData.itemgroups);
      this.errormsg = "";
      if (!this.eventData.date_start) {
        this.errormsg = "Kies een startdatum";
        return false;
      }

      var event = this.eventData;
      var settings = this.eventtype_config;
      if (!settings) {
        settings = {};
      }
      settings.absence_user_id = event.selected_absentMembers;
      delete settings.reoccurence;
      delete settings.reoccurence_type;
      delete settings.reoccurence_day;

      var formData = new FormData();
      formData.append("title", event.title);
      formData.append("description", event.description ?? "");
      formData.append("remarks", event.remarks ?? "");
      formData.append("remarks", event.remarks ?? "");
      formData.append("eventtype_id", event.eventtype_id ?? "");
      formData.append("active", event.active);
      formData.append("public", event.public);
      formData.append("address", event.address);
      formData.append("itemgroups", JSON.stringify(event.itemgroups));
      formData.append(
        "absence_by_attendees",
        event.absence_by_attendees ? 1 : 0
      );
      formData.append("settings", JSON.stringify(settings));
      formData.append(
        "selected_committees",
        JSON.stringify(event.selected_committees ?? [])
      );
      formData.append(
        "selected_members",
        JSON.stringify(event.selected_members ?? [])
      );
      formData.append(
        "selected_items",
        JSON.stringify(event.selected_items ?? [])
      );
      formData.append("date_start", event.date_start);
      formData.append("date_end", event.date_end ?? "");

      let url = "api/v1/events";

      if (event.id) {
        formData.append("_method", "PUT");
        url = "api/v1/events/" + event.id;
      }

      this.$store
        .dispatch("post", {
          endpoint: url,
          details: formData,
        })
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    getUsers() {
      this.$store
        .dispatch("get", "/api/v1/users")
        .then((data) => {
          this.users = data.data.data;
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    eventtypeSelected() {
      var id = this.eventData.eventtype_id;
      var eventtype = this.eventtypes.find((d) => d.id == id);
      if (eventtype) {
        var settings = JSON.parse(eventtype.settings);
        var config = {};
        if (settings.absence_by_attendees) {
          config = settings.absence_by_attendees;
          this.eventTypeAbsenceByAttendees = config;
        }

        if (settings.reoccurence_config) {
          config = settings.reoccurence_config;
          this.eventtype_config = config;
          this.eventData.date_start =
            config.start_date + " " + config.start_time;
          this.eventData.date_end = config.end_date + " " + config.end_time;

          return false;
        }

        let start_date = null;
        let start_time = null;
        let end_date = null;
        let end_time = null;

        if (this.eventData.date_start) {
          let start_datetime = this.eventData.date_start.split(" ");
          start_date = start_datetime[0]
            .split("-")
            .reverse()
            .join("-");
          start_time = start_datetime[1];
        }

        if (this.eventData.date_end) {
          let end_datetime = this.eventData.date_end.split(" ");
          end_date = end_datetime[0]
            .split("-")
            .reverse()
            .join("-");
          end_time = end_datetime[1];
        }

        this.eventtype_config = null;
        this.eventData.date_start = start_date
          ? start_date + " " + start_time
          : null;
        this.eventData.date_end = end_date ? end_date + " " + end_time : null;
      }
    },
    getItemgroups() {
      this.$store.dispatch("get", "api/v1/itemgroups").then((data) => {
        data.data.data.forEach((c) => {
          this.itemgroups.push({
            value: c.id,
            label: c.title,
          });
        });
      });
    },
  },
  async created() {
    this.getUsers();
    this.getItemgroups();
    if (this.event.id) {
      this.eventData = { ...this.event };
      this.eventData.date_start = moment(this.eventData.date_start).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.eventData.date_end = moment(this.eventData.date_end).format(
        "YYYY-MM-DDTHH:mm"
      );
      this.eventtypeSelected();
      this.eventData.selected_members = this.eventData.attendees.map(
        (m) => m.id
      );

      this.$store
        .dispatch("get", "api/v1/event-all-committees/" + this.eventData.id)
        .then((data) => {
          this.eventData.selected_committees = data.data;
        });

      this.$store
        .dispatch("get", "api/v1/event-items/" + this.eventData.id)
        .then((data) => {
          console.log("ITEMS", data.data);
          this.eventData.selected_items = data.data;
        });
    }
    window.tinymce.init({
      selector: "#eventdesc",
      height: 200,
      menubar: false,
      language: "nl",
      plugins: [
        "advlist autolink lists link image charmap print preview anchor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table paste code help wordcount",
      ],
      toolbar:
        "undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help",
    });

    this.$store.dispatch("get", "api/v1/active/users").then((data) => {
      data.data.data.forEach((m) => {
        this.members.push({
          value: m.id,
          label: m.display_name,
        });
      });
    });
    await this.$store.dispatch("get", "api/v1/committees-all").then((data) => {
      data.data.data.forEach((c) => {
        this.committees.push({
          value: c.id,
          label: c.title,
        });
      });
    });

    this.$store.dispatch("get", "api/v1/items-for-list").then((data) => {
      data.data.data
        .sort((a, b) => (a.title > b.title && 1) || -1)
        .forEach((c) => {
          this.items.push({
            value: c.id,
            label: c.title,
          });
        });
    });
  },
  watch: {
    "eventData.date_start": function(val) {
      if (val != null && val != "") {
        if (this.eventData.date_end == null || this.eventData.date_end == "")
          this.eventData = {
            ...this.eventData,
            date_end: moment(val)
              .add(1, "hours")
              .format("YYYY-MM-DDTHH:mm"),
          };
      }
    },
    start_date: function(v) {
      this.eventData = {
        ...this.eventData,
        date_start: v,
      };
    },
  },
};
</script>

<style>
.multiselect {
  min-height: calc(1.5em + 0.75rem + 2px) !important;
  /* min-height: 0 !important; */
}
</style>
<style scoped>
.collapsed {
  color: black;
  text-decoration: none;
}
.form-control {
  height: calc(1.5em + 0.75rem + 4px);
}
</style>
